import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row" }
const _hoisted_2 = { class: "card kn-flex" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  class: "kn-list-item",
  "data-test": "list-item"
}
const _hoisted_5 = { class: "kn-list-item-text" }
const _hoisted_6 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_7 = { class: "p-field p-col-12 p-mt-4" }
const _hoisted_8 = { class: "p-float-label p-mb-2" }
const _hoisted_9 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_10 = { class: "p-field-checkbox p-ml-2" }
const _hoisted_11 = { for: "versioning" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_KpiDefinitionFormulaTab = _resolveComponent("KpiDefinitionFormulaTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_KpiDefinitionCardinalityTab = _resolveComponent("KpiDefinitionCardinalityTab")
  const _component_KpiDefinitionThresholdTab = _resolveComponent("KpiDefinitionThresholdTab")
  const _component_TabView = _resolveComponent("TabView")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_AutoComplete = _resolveComponent("AutoComplete")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-m-0" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.selectedKpi.name), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.$t('kpi.kpiDefinition.aliasToolbarTitle'),
          style: _ctx.tabViewDescriptor.style.aliasButton,
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.toggleAlias
        }, null, 8, ["label", "style", "onClick"]),
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSaveDialog = true)),
          disabled: _ctx.buttonDisabled
        }, null, 8, ["disabled"]),
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.closeTemplateConfirm
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_TabView, {
          activeIndex: _ctx.activeTab,
          "onUpdate:activeIndex": _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeTab = $event)),
          class: "tabview-custom",
          "data-test": "tab-view"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TabPanel, null, {
              header: _withCtx(() => [
                _createVNode("span", null, _toDisplayString(_ctx.$t('kpi.kpiDefinition.formulaTitle')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_KpiDefinitionFormulaTab, {
                  propKpi: _ctx.selectedKpi,
                  measures: _ctx.measureList,
                  loading: _ctx.loading,
                  aliasToInput: _ctx.aliasToInput,
                  checkFormula: _ctx.checkFormula,
                  activeTab: _ctx.activeTab,
                  reloadKpi: _ctx.reloadKpi,
                  showGuide: _ctx.showGuide,
                  onUpdateFormulaToSave: _ctx.onUpdateFormulaToSave,
                  onErrorInFormula: _ctx.ifErrorInFormula,
                  onTouched: _ctx.setTouched,
                  onOnGuideClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onGuideClose')))
                }, null, 8, ["propKpi", "measures", "loading", "aliasToInput", "checkFormula", "activeTab", "reloadKpi", "showGuide", "onUpdateFormulaToSave", "onErrorInFormula", "onTouched"])
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, null, {
              header: _withCtx(() => [
                _createVNode("span", null, _toDisplayString(_ctx.$t('kpi.kpiDefinition.cardinalityTtitle')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_KpiDefinitionCardinalityTab, {
                  selectedKpi: _ctx.selectedKpi,
                  loading: _ctx.loading,
                  updateMeasureList: _ctx.updateMeasureList,
                  onMeasureListUpdated: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateMeasureList = false))
                }, null, 8, ["selectedKpi", "loading", "updateMeasureList"])
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, null, {
              header: _withCtx(() => [
                _createVNode("span", null, _toDisplayString(_ctx.$t('kpi.kpiDefinition.tresholdTitle')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_KpiDefinitionThresholdTab, {
                  selectedKpi: _ctx.selectedKpi,
                  thresholdsList: _ctx.tresholdList,
                  severityOptions: _ctx.severityOptions,
                  thresholdTypeList: _ctx.thresholdTypeList,
                  loading: _ctx.loading,
                  onTouched: _ctx.setTouched
                }, null, 8, ["selectedKpi", "thresholdsList", "severityOptions", "thresholdTypeList", "loading", "onTouched"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeIndex"])
      ]),
      (_ctx.isAliasVisible)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_Toolbar, {
              class: "kn-toolbar kn-toolbar--secondary",
              style: _ctx.tabViewDescriptor.style.aliasList
            }, {
              start: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('kpi.kpiDefinition.aliasToolbarTitle')), 1)
              ]),
              _: 1
            }, 8, ["style"]),
            _createVNode(_component_Listbox, {
              class: "kn-list--column",
              options: _ctx.measureList,
              filter: true,
              filterPlaceholder: _ctx.$t('common.search'),
              optionLabel: "alias",
              filterMatchMode: "contains",
              filterFields: _ctx.tabViewDescriptor.filterFields,
              emptyFilterMessage: _ctx.$t('common.info.noDataFound'),
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.insertAlias($event.value.alias))),
              "data-test": "kpi-list"
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
              ]),
              option: _withCtx((slotProps) => [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("span", null, _toDisplayString(slotProps.option.alias), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["options", "filterPlaceholder", "filterFields", "emptyFilterMessage"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Dialog, {
        id: "saveDialog",
        class: "kn-dialog--toolbar--primary importExportDialog",
        style: _ctx.tabViewDescriptor.style.saveDialog,
        visible: _ctx.showSaveDialog,
        footer: "footer",
        closable: false,
        modal: ""
      }, {
        header: _withCtx(() => [
          _createVNode("h4", null, _toDisplayString(_ctx.$t('kpi.kpiDefinition.addKpiAssociations')), 1)
        ]),
        footer: _withCtx(() => [
          _createVNode("div", null, [
            _createVNode(_component_Button, {
              class: "kn-button kn-button--secondary",
              label: _ctx.$t('common.cancel'),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showSaveDialog = false))
            }, null, 8, ["label"]),
            _createVNode(_component_Button, {
              class: "kn-button kn-button--primary",
              label: _ctx.$t('common.save'),
              onClick: _ctx.saveKpi,
              disabled: _ctx.v$.$invalid
            }, null, 8, ["label", "onClick", "disabled"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode("form", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("span", _hoisted_8, [
                _createVNode(_component_AutoComplete, {
                  modelValue: _ctx.v$.selectedKpi.category.$model,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.selectedKpi.category.$model = $event)),
                  class: {
                                'p-invalid': _ctx.v$.selectedKpi.category.$invalid && _ctx.v$.selectedKpi.category.$dirty
                            },
                  suggestions: _ctx.filteredCategories,
                  field: "valueName",
                  onComplete: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setAutocompleteCategory($event)))
                }, null, 8, ["modelValue", "class", "suggestions"]),
                _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('managers.configurationManagement.headers.category')) + " *", 1)
              ]),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.v$.selectedKpi.category,
                additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.configurationManagement.headers.category')
                        }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_Checkbox, {
                id: "versioning",
                modelValue: _ctx.selectedKpi.enableVersioning,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedKpi.enableVersioning = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('kpi.kpiDefinition.enableVersioning')), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["style", "visible"])
    ])
  ], 64))
}